import { render, staticRenderFns } from "./SearchResultListAuthor.vue?vue&type=template&id=06cdf827&scoped=true&"
import script from "./SearchResultListAuthor.vue?vue&type=script&lang=js&"
export * from "./SearchResultListAuthor.vue?vue&type=script&lang=js&"
import style0 from "./SearchResultListAuthor.vue?vue&type=style&index=0&id=06cdf827&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cdf827",
  null
  
)

export default component.exports